export const isCustomMobileWidth = () => window.innerWidth < 448
export const isCustomTabletWidth = () => window.innerWidth > 447 && window.innerWidth < 768
export const isCustomLaptopWidth = () => window.innerWidth > 767 && window.innerWidth < 1280
